let alreadyAssigned = false;
const runtimeConfig = {};

export function setRuntimeConfig(config) {
  if (alreadyAssigned) {
    throw new Error('Runtime config can only be set once.');
  }
  alreadyAssigned = true;
  return Object.assign(runtimeConfig, config);
}

export default runtimeConfig;
